import LogoutExecutor from './LogoutExecutor';
import LogoutProvider from './LogoutProvider';

export interface UserSessionProviderApi {
  logoutProvider: LogoutProvider;
  logoutExecutor: LogoutExecutor;
  logoutCallback: () => void;
}

const logoutExecutor = new LogoutExecutor();

const logoutCallback = () => {
  logoutExecutor.doLogout();
};

const api: UserSessionProviderApi = {
  logoutProvider: new LogoutProvider(logoutCallback, window),
  logoutExecutor,
  logoutCallback,
};

// Allow for debugging in Online context
if (window.ori && !window.ori.userSessionProvider) {
  window.ori.userSessionProvider = api;
}

export default api;
